import {InfoCircleOutlined} from '@ant-design/icons';
import {Button, Tooltip} from 'antd';
import React from 'react';

import {createActionGetFile} from 'modules/data/data-actions';
import {ERequestType} from 'shared/types/requests';
import {useAppDispatch} from 'store/config/hooks';
import {IMonitoringProgram, IMonitoringResultLog} from 'store/slices/documents-uploading-slice';

import './documents-upload-log.less';

export interface IDocumentsUploadLogProps {
    program: IMonitoringProgram;
    log: IMonitoringResultLog;
}

export const DocumentsUploadLog = ({program, log}: IDocumentsUploadLogProps) => {
    const dispatch = useAppDispatch();
    const handleLogDownload = async (monitorProgramRequest: number) => {
        await dispatch(createActionGetFile({
            isMessage: true,
            requestType: ERequestType.GET,
            referenceUrl: `administration.monitor.programs/download/${monitorProgramRequest}`,
        }));
    };

    return (
        <div className="monitoring-log">
            <div className="program-name">{program.name}</div>
            <Tooltip
                placement="top"
                title={log?.description || 'Для данной программы нет лога'}
            >
                <InfoCircleOutlined />
            </Tooltip>
            {log?.monitorProgramRequest && log?.nameFile && (
                <Button
                    type="default"
                    onClick={() => handleLogDownload(log.monitorProgramRequest)}
                >Выгрузить лог
                </Button>
            )}
        </div>
    );
};
